"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.JCTWriter = void 0;
var TokenFormat_1 = require("./TokenFormat");
var TokenValidator_1 = __importStar(require("./TokenValidator"));
var JSONSignedCertificate_1 = __importDefault(require("./JSONSignedCertificate"));
var Timestamp_1 = require("./Timestamp");
var RSA_1 = __importDefault(require("./RSA"));
var ResourceIdentifier_1 = require("./ResourceIdentifier");
var Telemetry_1 = require("./Telemetry");
var debug_1 = __importDefault(require("debug"));
var wrapLine_1 = require("./wrapLine");
/**
 * A JSON Chained Token is comprised of:
 * - JOSE Header
 * - Body
 * - 0-N JSON Signed Certificate
 * - Signature
 *
 * Size is about 200 bytes overhead for the chained token, plus about 500 per
 * certificate in the chain, plus the payload
 */
var JCTWriter = /** @class */ (function () {
    function JCTWriter(cert, prv) {
        if (!('keyid' in cert.pub)) {
            (0, debug_1.default)('lightweight certificate, no keyid provided');
        }
        else if (prv.keyid !== cert.pub.keyid) {
            throw new Error('Private key id does not match certificate keyid');
        }
        this.cert_str = cert.raw;
        this.prv = prv;
        this.cert = cert;
    }
    /**
     * Returns a signed chained token, with the certificate chain included in
     * the protected payload.
     * @param body content to encode and put in the chained token body
     */
    JCTWriter.prototype.sign = function (body_1) {
        return __awaiter(this, arguments, void 0, function (body, exp_in, compressed, lightWeight) {
            var headers, now, unsigned_token, signature, raw_token;
            if (exp_in === void 0) { exp_in = undefined; }
            if (compressed === void 0) { compressed = false; }
            if (lightWeight === void 0) { lightWeight = false; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        headers = {
                            typ: 'JCT',
                        };
                        if (lightWeight !== true) {
                            headers.kid = this.prv.keyid;
                            headers.alg = 'RS256';
                        }
                        else {
                            headers.typ += ':L';
                        }
                        now = (0, Timestamp_1.now)();
                        if (!('iat' in body)) {
                            body.iat = now;
                        }
                        if (exp_in && !('exp' in body)) {
                            body.exp = now + (typeof exp_in === 'number' ? exp_in : parseInt(exp_in));
                        }
                        if (compressed === true) {
                            if (headers.typ === 'JCT:L') {
                                headers.typ += 'C';
                            }
                            else {
                                headers.cmp = 'zlib';
                            }
                        }
                        unsigned_token = [(0, TokenFormat_1.encode)(headers), (0, TokenFormat_1.encode)(body, compressed), this.cert_str].join('.');
                        return [4 /*yield*/, RSA_1.default.sign(this.prv, unsigned_token)];
                    case 1:
                        signature = _a.sent();
                        raw_token = unsigned_token + '.' + signature;
                        return [2 /*return*/, raw_token];
                }
            });
        });
    };
    return JCTWriter;
}());
exports.JCTWriter = JCTWriter;
/**
 * This class will parse and validate integrity of a JCT
 */
var JCT = /** @class */ (function () {
    function JCT(raw) {
        this.originalLength = raw.length;
        this.validator = new TokenValidator_1.default(raw, 
        /**
         * Length description:
         *  JWT (header, body, signature) = 3
         *  JSC(s) (header, body, pubkey, signature) = 4
         *
         * therefore, remainder of length-JWT must be a multiple of 4
         */
        function (n) { return (n - 3) % 4 === 0 && n >= 3; }, ['JCT', 'JCT:L', 'JCT:LC']);
        var compressed = this.validator.header.cmp === 'zlib' || this.validator.header.typ === 'JCT:LC';
        this.body = new TokenFormat_1.Body(this.validator.next_is_body(true, compressed));
        this.cert = new JSONSignedCertificate_1.default(this.validator.next_few(-1));
    }
    Object.defineProperty(JCT.prototype, "raw", {
        get: function () {
            return this.validator.raw();
        },
        enumerable: false,
        configurable: true
    });
    /**
     * This will verify the complete integrity and valid status of this chained
     * token.
     * Tests are made in order to fail early, with synchronous test executed
     * first, and then asynchronous test launched at the same time.
     * @param authorities that should contain all issuers
     */
    JCT.prototype.verify = function (authorities, options) {
        return __awaiter(this, void 0, void 0, function () {
            var telemetry, valid;
            var _this = this;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        telemetry = (_a = options === null || options === void 0 ? void 0 : options.telemetry) !== null && _a !== void 0 ? _a : new Telemetry_1.Telemetry('JCT verify');
                        // verify token
                        if (this.is_token_expired(options === null || options === void 0 ? void 0 : options.now)) {
                            return [2 /*return*/, [false, [TokenValidator_1.ValidationError.Expired]]];
                        }
                        return [4 /*yield*/, telemetry.seq('JCT verifying signature', function (t) { return _this.verify_token_signature(t); })];
                    case 1:
                        // verify signature
                        if (!(_b.sent())) {
                            return [2 /*return*/, [false, [TokenValidator_1.ValidationError.InvalidSignature]]];
                        }
                        return [4 /*yield*/, telemetry.seq('JCT verify cert', function (t) {
                                return _this.cert.verify(authorities, __assign(__assign({}, options), { telemetry: t }));
                            })];
                    case 2:
                        valid = _b.sent();
                        return [2 /*return*/, valid];
                }
            });
        });
    };
    /**
     */
    JCT.prototype.verify_integrity = function (authorities, options) {
        return __awaiter(this, void 0, void 0, function () {
            var telemetry, valid;
            var _this = this;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        telemetry = (_a = options === null || options === void 0 ? void 0 : options.telemetry) !== null && _a !== void 0 ? _a : new Telemetry_1.Telemetry('JCT verify_integrity');
                        // verify token
                        if (this.is_token_expired(options === null || options === void 0 ? void 0 : options.now)) {
                            return [2 /*return*/, [false, [TokenValidator_1.ValidationError.Expired]]];
                        }
                        return [4 /*yield*/, telemetry.seq('JCT veryfying signature', function (t) { return _this.verify_token_signature(t); })];
                    case 1:
                        if (!(_b.sent())) {
                            return [2 /*return*/, [false, [TokenValidator_1.ValidationError.InvalidSignature]]];
                        }
                        return [4 /*yield*/, telemetry.seq('JCT verify cert integrity', function (t) {
                                return _this.cert.verify_integrity(authorities, __assign(__assign({}, options), { telemetry: t }));
                            })];
                    case 2:
                        valid = _b.sent();
                        return [2 /*return*/, valid];
                }
            });
        });
    };
    Object.defineProperty(JCT.prototype, "expireTimestamp", {
        /**
         * Returns the earliest expiration between this token and it's cert chain
         */
        get: function () {
            var payload_exp = this.body.val('exp');
            var cert_exp = this.cert.expireTimestamp;
            if (payload_exp === null || cert_exp < payload_exp) {
                return cert_exp;
            }
            return payload_exp;
        },
        enumerable: false,
        configurable: true
    });
    JCT.prototype.is_token_expired = function (now) {
        if (now === void 0) { now = undefined; }
        if (now !== false) {
            if (now === undefined || now === true) {
                now = (0, Timestamp_1.now)();
            }
            // expireTimestamp returns the earliest defined expiration amongst
            // the tokena nd all cert, so testing this once instance confirms
            // the whole chain
            return this.expireTimestamp < now;
        }
        return false;
    };
    JCT.prototype.verify_token_signature = function (telemetry) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validator.signature_matches(this.cert.pub, telemetry)];
                    case 1:
                        if (!(_a.sent())) {
                            return [2 /*return*/, false];
                        }
                        return [2 /*return*/, true];
                }
            });
        });
    };
    JCT.prototype.formatHumanReadable = function () {
        return [
            '# Header (' + this.validator.at(0).length + ' bytes)',
            '# ' + this.validator.at(0),
            JSON.stringify(this.validator.header),
            '\n# Payload (' + this.validator.at(1).length + ' bytes)',
            '# ' + (0, wrapLine_1.wrapLine)(this.validator.at(1)).join('\n# '),
            JSON.stringify(this.body.all, null, 4),
            '\n# Certificates',
            JSONSignedCertificate_1.default.format(this.cert),
            '\n# Signature (' + this.validator.signature.length + ' bytes)',
            this.validator.signature,
            '\n#--------------------------- Meta -----------------------------',
            "Length: ".concat(this.validator.raw().length),
        ].join('\n');
    };
    Object.defineProperty(JCT.prototype, "sub", {
        // helper function to return agent information
        get: function () {
            return this.cert.sub;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(JCT.prototype, "identity", {
        get: function () {
            return this.cert.identity;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(JCT.prototype, "agent_cert", {
        // returns the certificate that was signed to the agent, who is the party
        // that signed this token
        get: function () {
            return this.cert;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(JCT.prototype, "agent_sub", {
        get: function () {
            return this.agent_cert.sub;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(JCT.prototype, "agent_identity", {
        get: function () {
            return this.agent_cert.identity;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(JCT.prototype, "service_cert", {
        // returns, if any, the next certificate in the chain. If more than 1
        // certificate is included between the owner and the root authority, manual
        // parsing of .certs is recommended
        get: function () {
            return this.cert.ancestor_certificate;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(JCT.prototype, "service_sub", {
        get: function () {
            var _a;
            return (_a = this.service_cert) === null || _a === void 0 ? void 0 : _a.sub;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(JCT.prototype, "service_identity", {
        get: function () {
            var _a;
            return (_a = this.service_cert) === null || _a === void 0 ? void 0 : _a.identity;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Combining scopes and authorized_resource, this will validate if the
     * requested permission is allowed to the specified uri
     * @param uri Resource uri to check for
     * @param permission what to look for
     */
    JCT.prototype.isAllowed = function (uri, permission) {
        var permissions = this.getPermissions(uri);
        // all permissions are to be handled in lower case
        if (permissions.includes(permission.toLowerCase())) {
            return true;
        }
        return false;
    };
    /**
     * Combining scopes and authorized_resource, this will return the
     * permissions that are for sure allowed on this token
     * @param uri Resource to check for
     */
    JCT.prototype.getPermissions = function (uri) {
        var scopePermissions = this.getScopePermissions(uri);
        var authorizedResource = this.service_authorized_resource;
        if (authorizedResource && this.service_authorized_resource_uri === uri) {
            return authorizedResource.permissions.filter(function (p) { return scopePermissions.includes(p); });
        }
        return [];
    };
    /**
     * Will check through the different scopes in the provided token, and will
     * validate if the desired permissions is allowed for the specified uri
     *
     * This will also handle wildcard
     * @param uri Resource uri to check for
     * @param permission what to look for
     */
    JCT.prototype.isScopeAllowed = function (uri, permission) {
        var scopePermissions = this.getScopePermissions(uri);
        // confirm the most restrictive application of a permission fit the uri
        var allowedPermissions = scopePermissions.filter(function (prm) {
            return wildStringToRegex(scopePermissions.mostRestrictiveUriPerPermissions[prm]).test(uri);
        });
        return JCT.filterOutPermissions(allowedPermissions, [permission.toLowerCase()]).length > 0;
    };
    /**
     * Given a list of allowed permissions, return the list of check permission
     * that are either an exact match, or matches with a wildcard (if the
     * allowed permission contained one)
     * @param allowedPermissions
     * @param checkPermissions
     * @returns
     */
    JCT.filterOutPermissions = function (allowedPermissions, checkPermissions) {
        return checkPermissions.filter(function (checkPermission) {
            return -1 !==
                allowedPermissions.findIndex(function (allowedPermission) {
                    // exact match
                    return allowedPermission === checkPermission ||
                        // contains a wildcard and matches
                        (allowedPermission.includes('*') &&
                            new RegExp(
                            // force a full match
                            '^' +
                                allowedPermission
                                    // excape regex wildcard caracter for
                                    // exact match
                                    .replace(/[.]/g, '\\$1')
                                    // replace wild card caracter
                                    .replace(/\*/g, '.*') +
                                // force a full match
                                '$').test(checkPermission));
                });
        });
    };
    /**
     * return the complete list of permissions, as defined by the scopes, for
     * the given uri
     *
     * This does not ensure the user has actual access to the requested
     * resource, that remains to be validated using the authorized_resource
     * feature
     * @param uri Resource uri to check for
     */
    JCT.prototype.getScopePermissions = function (uri) {
        return JCT.extractPermissionsFromScopes(this.getScopes(), uri);
    };
    /**
     * Return the uri used to grant the desired permission to the uri with
     * wildcard sent.
     *
     * @param uri Resource uri (with wildcard) to check for
     */
    JCT.prototype.getScopeUriForPermission = function (uriWithWild, permission) {
        var r = JCT.extractPermissionsFromScopes(this.getScopes(), uriWithWild);
        if (r.includes(permission) && permission in r.mostRestrictiveUriPerPermissions) {
            return r.mostRestrictiveUriPerPermissions[permission];
        }
        else if (r.includes('*') && '*' in r.mostRestrictiveUriPerPermissions) {
            return r.mostRestrictiveUriPerPermissions['*'];
        }
        return null;
    };
    JCT.prototype.getScopes = function () {
        var scopes_list = this.cert.getFromEtcs('scopes');
        if ('scopes' in this.body.all) {
            var scopes = this.body.val('scopes');
            if (typeof scopes === 'string') {
                scopes_list.unshift([scopes]);
            }
            else if (scopes && typeof scopes === 'object' && scopes instanceof Array) {
                scopes_list.push(scopes);
            }
            else {
                console.warn('JCT unexpected body.scopes value, ignoring', scopes);
            }
        }
        return scopes_list;
    };
    JCT.extractPermissionsFromScopes = function (scopes_list, uri) {
        var permissions = null;
        var mostRestrictiveUriPerPermissions = {};
        var uriMatcher = doesUriMatches;
        if (uri.indexOf('*') !== -1) {
            var uriRegex_1 = wildStringToRegex(uri);
            uriMatcher = function isDesiredUri(scope_uri) {
                return doesUriMatches(scope_uri, uri) || uriRegex_1.test(scope_uri);
            };
        }
        for (var _i = 0, scopes_list_1 = scopes_list; _i < scopes_list_1.length; _i++) {
            var scopes = scopes_list_1[_i];
            // for each scope, as we dig down, we must have a match at every
            // level. getFromEtcs already only return the values that existed,
            // therefore certificate without the value will not be present in
            // this array.
            var thisLevelPrms = null;
            // try to find a match in this scopes array. These are all included
            // at the same level in the certificate
            for (var _a = 0, scopes_1 = scopes; _a < scopes_1.length; _a++) {
                var scope = scopes_1[_a];
                if (!JCT.scopeRegExp.test(scope)) {
                    console.warn('invalid scope " %s ", skipping', scope);
                    continue;
                }
                var inlineScopes = scope.split(' ');
                var thisLinePrms = null;
                // This parses multiple scopes that are defined on 1 line. The
                // main use for this are negative scope. Blacklist vs Whitelist
                for (var _b = 0, inlineScopes_1 = inlineScopes; _b < inlineScopes_1.length; _b++) {
                    var inlineScope = inlineScopes_1[_b];
                    // special handling of scope === '*', which grants all
                    // permissions
                    if (inlineScope === '*') {
                        thisLinePrms = ['*'];
                        if (!('*' in mostRestrictiveUriPerPermissions)) {
                            mostRestrictiveUriPerPermissions['*'] = '*';
                        }
                        continue;
                    }
                    var _c = inlineScope.split(','), scope_uri = _c[0], prms = _c.slice(1);
                    var negative = scope_uri.charAt(0) === '-';
                    if (uriMatcher(scope_uri, uri)) {
                        // it is a match
                        if (thisLinePrms === null) {
                            thisLinePrms = [];
                        }
                        if (prms && prms.length) {
                            for (var _d = 0, prms_1 = prms; _d < prms_1.length; _d++) {
                                var prm = prms_1[_d];
                                // all permissions are to be handled in lower case
                                var p = prm.toLowerCase();
                                if (negative) {
                                    // remove the permission from this line
                                    var indexOf = thisLinePrms.indexOf(p);
                                    if (indexOf !== -1) {
                                        thisLinePrms.splice(indexOf, 1);
                                    }
                                }
                                else {
                                    if (!(p in mostRestrictiveUriPerPermissions)) {
                                        mostRestrictiveUriPerPermissions[p] = scope_uri;
                                    }
                                    // add permissions to this line of permissions
                                    if (!thisLinePrms.includes(p)) {
                                        thisLinePrms.push(p);
                                    }
                                }
                            }
                        }
                        // a negative claim without permissions will invalidate all inline permissions
                        else if (negative && thisLinePrms !== null) {
                            thisLinePrms.length = 0;
                        }
                    }
                }
                if (thisLinePrms !== null) {
                    if (thisLevelPrms === null) {
                        thisLevelPrms = [];
                    }
                    for (var _e = 0, thisLinePrms_1 = thisLinePrms; _e < thisLinePrms_1.length; _e++) {
                        var p = thisLinePrms_1[_e];
                        if (!thisLevelPrms.includes(p)) {
                            thisLevelPrms.push(p);
                        }
                    }
                }
            }
            if (thisLevelPrms !== null) {
                // apply permissions here
                if (permissions === null) {
                    permissions = thisLevelPrms;
                }
                else {
                    // filter out permissions according to what is in prms,
                    // allowing wildcard validation
                    permissions = JCT.filterOutPermissions(thisLevelPrms, permissions);
                }
            }
        }
        var r = permissions !== null && permissions !== void 0 ? permissions : [];
        r.mostRestrictiveUriPerPermissions = {};
        for (var prm in mostRestrictiveUriPerPermissions) {
            if (r.includes(prm)) {
                r.mostRestrictiveUriPerPermissions[prm] = mostRestrictiveUriPerPermissions[prm];
            }
        }
        return r;
    };
    Object.defineProperty(JCT.prototype, "service_authorized_resource", {
        /**
         * Return the information about the resource that was authorized with the
         * certificate used to sign this token
         */
        get: function () {
            var cert = this.service_cert;
            if (!cert) {
                return;
            }
            var etc = cert.body.etc;
            if (!etc) {
                return;
            }
            if ('resId' in etc && 'resTyp' in etc) {
                // agent level permissions limit permissions from
                var permissions_list = this.cert.getFromEtcs('prms');
                if (permissions_list.length > 0) {
                    var permissions_1 = [];
                    for (var prms = permissions_list.pop(); prms; prms = permissions_list.pop()) {
                        if (permissions_1.length) {
                            // only pass along the values that were granted by an older certificate
                            permissions_1 = prms.filter(function (prm) { return permissions_1.includes(prm); });
                        }
                        else {
                            // first permissions we see, pass them all along
                            permissions_1 = prms;
                        }
                    }
                    return {
                        resourceId: etc.resId,
                        resourceType: etc.resTyp,
                        permissions: permissions_1,
                        serviceId: cert.sub,
                        serviceIdentity: cert.identity,
                    };
                }
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(JCT.prototype, "service_authorized_resource_uri", {
        /**
         * Return a unique uri that represent a resource on a given service. This
         * will include service account information, resource type and resource id
         */
        get: function () {
            var res = this.service_authorized_resource;
            if (res) {
                return (0, ResourceIdentifier_1.resourceToUri)(res);
            }
            return;
        },
        enumerable: false,
        configurable: true
    });
    JCT.scopeRegExp = /^[a-zA-Z0-9:.,/*_ -]+$/;
    return JCT;
}());
exports.default = JCT;
function doesUriMatches(scope_uri, uri) {
    var negative = scope_uri.charAt(0) === '-';
    var exp = wildStringToRegex(negative ? scope_uri.substr(1) : scope_uri);
    return exp.test(uri);
}
// transform uri into regexp tha must match the whole uri
function wildStringToRegex(uri) {
    return new RegExp('^' + uri.replace(/\*/g, '[^,]*').replace(/[.]/g, '\\.') + '$');
}
